module.exports = __webpack_public_path__ + "img/08.5279ff74.png";